// XXX: https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
export const getFbp = (): string | undefined => {
  const match = document.cookie.match(/ ?_fbp=([^;]+)/);
  if (!match) return;
  return match[1];
};
